import BaseAPI from './base'
/**
 * API xử lý lớp học
 */
class StudentExerciseAPI extends BaseAPI {}

export default new StudentExerciseAPI('v1/student-exercises', 'StudentExercise')
